import { useTheme } from '../../contexts/ThemeContext'

interface ThemeToggleProps {
  variant?: 'desktop' | 'mobile'
}

export default function ThemeToggle({ variant = 'desktop' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme()

  if (variant === 'mobile') {
    return (
      <div className="flex items-center justify-center pt-3 mt-2 border-t border-gold-500/30">
        <button
          onClick={toggleTheme}
          className={`w-full py-3 px-4 flex items-center justify-center gap-2 font-semibold transition-all duration-300 active:scale-95 rounded-lg border border-gold-500/30 ${
            theme === 'dark'
              ? 'text-gold-400 hover:text-gold-300 hover:bg-gold-900/20 active:bg-gold-900/30'
              : 'text-gray-700 hover:text-gray-900 hover:bg-gold-400/20 active:bg-gold-400/30'
          }`}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? (
            <>
              <i className="pi pi-sun text-lg"></i>
              <span>Chế độ sáng</span>
            </>
          ) : (
            <>
              <i className="pi pi-moon text-lg"></i>
              <span>Chế độ tối</span>
            </>
          )}
        </button>
      </div>
    )
  }

  return (
    <button
      onClick={toggleTheme}
      className={`w-10 h-10 flex items-center justify-center transition-all duration-300 rounded-lg active:scale-95 ${
        theme === 'dark'
          ? 'text-gold-400 hover:text-gold-300 hover:bg-gold-900/20'
          : 'text-gray-700 hover:text-gray-900 hover:bg-gold-400/20'
      }`}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <i className="pi pi-sun text-lg"></i>
      ) : (
        <i className="pi pi-moon text-lg"></i>
      )}
    </button>
  )
}

